import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, onUnmounted } from 'vue'
import { setInterval, clearInterval } from 'timers'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: {
  time: {
    type: String,
    default: ''
  }
},
  emits: ['out'],
  setup(__props, { emit }) {

const props = __props


const timeSet = ref('')
let timer: any = null
timer = setInterval(() => {
  var date1 = new Date() // 开始时间
  var date2 = new Date(props.time) // 结束时间
  var date3 = date2.getTime() - date1.getTime() // 时间差的毫秒数
  if (isNaN(date3)) {
    console.log('格式有误')
    clearInterval(timer)
    return
  }
  if (date3 < 0) {
    emit('out')
    clearInterval(timer)
    return
  }
  // 计算出相差天数
  var days = Math.floor(date3 / (24 * 3600 * 1000))
  // 计算出小时数
  var leave1 = date3 % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))
  // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.floor(leave3 / 1000)
  var time = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
  // TODO
  timeSet.value = t('剩余XX天hh:mm:ss自动扣款').replace('XX', days).replace('hh:mm:ss', time)
}, 1000)
onUnmounted(() => {
  clearInterval(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(timeSet.value), 1))
}
}

})